import * as React from 'react';
import * as PropTypes from 'prop-types';
import * as StudentActions from '../../actions/student';
import * as StoryActions from '../../actions/story';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { RootState } from '../../reducers';
import { StudentData } from '../../models/Student';
import { CampaignData } from '../../models/Campaign';
import { StoryInfo } from '../../models/Story';
import evaluations from '../../constants/evaluations';
import { Status } from './status';
import { Diary } from './diary';
import Logout from '../Common/logout';

export namespace Campaign {
	export interface Props extends RouteComponentProps<void> {
		studentActions: typeof StudentActions;
		storyActions: typeof StoryActions;
		student: StudentData;
		campaign: CampaignData;
		stories: StoryInfo[];
	}

	export interface State {
		tab: number;
	}
}

@connect(mapStateToProps, mapDispatchToProps)
export default class Campaign extends React.Component<Campaign.Props, Campaign.State> {

	static contextTypes = {
		router: PropTypes.func.isRequired
	}

	constructor(props: Campaign.Props) {
		super(props);
		this.tellStory = this.tellStory.bind(this);
		this.viewStory = this.viewStory.bind(this);
		this.deleteStory = this.deleteStory.bind(this);
		this.switchTab = this.switchTab.bind(this);
		this.state = { tab: 0 };
	}

	tellStory() {
		this.context.router.history.push("/play/" + this.props.campaign._id + "/" + (this.props.student._id + Date.now()));
	}

	viewStory(id: string) {
		this.context.router.history.push("/play/" + this.props.campaign._id + "/" + id);
	}

	deleteStory(id: string) {
		const { storyActions, stories } = this.props;
		const story = stories.find((story) => story._id === id);
		storyActions.deleteStory(story);
	}

	switchTab(i) {
		this.setState({ tab: i });
	}

	render() {
		const { student, campaign, stories } = this.props;

		if (!campaign) return <div />;

		let content;

		if (this.state.tab === 0) {
			content = <Status evaluations={campaign.evaluations} stories={stories} bigIcons={true} />;
		} else if (this.state.tab === 1) {
			content = <Diary stories={stories} viewStory={this.viewStory} deleteStory={this.deleteStory} />;
		}

		return (
			<div className="row m-3">
				<div className="row col-12">
					<div className='col-3'>
						<img className="am_mainLogo_small" src="/images/Arviointimaa-logo.png" />
					</div>
					<h3 className="am_title col-6 text-center">{student.firstname + " " + student.lastname}</h3>
					<div className="col-3 text-right">
						<Logout />
					</div>
				</div>
				<div className="jumbotron am_studentcontainer col-12">
					<div className="row">
						<h3 className="col-4 am_backbutton" onClick={this.context.router.history.goBack}>
							<img src="/images/BackArrow.png" />
							Kampanjat
						</h3>
						<h3 className="am_title col-8">{campaign.name}</h3>
					</div>
					<div className="col-12 p-2">
						<div className="row pl-3 pr-3">
							<button onClick={() => { this.switchTab(0) }} className={"col-6 btn am_darkblue-button am_campaignbutton" + (this.state.tab === 0 ? " selected" : "")}>TILANNEKATSAUS</button>
							<button onClick={() => { this.switchTab(1) }} className={"col-6 btn am_darkblue-button am_campaignbutton" + (this.state.tab === 1 ? " selected" : "")}>PÄIVÄKIRJA</button>
						</div>
						<div className="am_flex am_whitecontainer">
							{content}
						</div>
						<button onClick={this.tellStory} className="col-12 btn am_green-button mt-2">KERRO UUSI TARINA</button>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state: RootState, data: any) {

	let campaign;
	var id = data.match.params.id;
	if (state.groups[0]) {
		campaign = state.groups[0].campaigns.find((o) => { return o._id === id });
	} else {
		campaign = null;
	}

	let stories = state.stories.filter((o) => { return o.campaign === campaign._id });

	return {
		student: state.student,
		campaign: campaign,
		stories: stories
	};
}

function mapDispatchToProps(dispatch: Dispatch<Function>) {
	return {
		studentActions: bindActionCreators(StudentActions as {}, dispatch),
		storyActions: bindActionCreators(StoryActions as {}, dispatch)
	};
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/Campaign/index.tsx